"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskBoard = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@dnd-kit/core");
const core_2 = require("@material-ui/core");
const icons_1 = require("@material-ui/icons");
const core_ui_1 = require("@sierralabs/core-ui");
const useFindTasksByType_1 = require("../hooks/useFindTasksByType");
const useGetTaskEntity_1 = require("../hooks/useGetTaskEntity");
const useTaskBoard_1 = require("../hooks/useTaskBoard");
const BoardColumn_1 = __importDefault(require("./board/BoardColumn"));
const BoardItem_1 = __importDefault(require("./board/BoardItem"));
const BoardItemWithSubTask_1 = __importDefault(require("./board/BoardItemWithSubTask"));
const TaskBoardStatusAction_1 = __importDefault(require("./TaskBoardStatusAction"));
const StyledBoard = styled_components_1.default.div `
  flex: 1;
  display: flex;
  margin: 0 -10px;
  &:not(.no-columns) {
    overflow-y: hidden;
    overflow-x: auto;
  }
  .column {
    display: flex;
    flex-direction: column;
    margin: 0 10px;
    flex: 1;
    border-radius: 4px 4px 0 0;
    min-width: 188px;
    /* overflow: hidden; */
  }
  .sub-column-container {
    /* overflow: hidden; */
  }
  .sub-column {
    /* flex: 50%; */
    height: 50%;
    display: flex;
    flex-direction: column;
    margin: 10px 0;
    /* overflow: hidden; */
    &:first-child {
      margin-top: 0;
    }
    &:last-child {
      margin-bottom: 0;
      border-radius: 4px 4px 0 0;
    }
  }
  .card-title {
    padding: 12px 16px;
    display: inline-block;
    overflow-x: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    border-bottom: 1px solid #ddd;
    transition: background 0.2s cubic-bezier(0.075, 0.82, 0.165, 1),
      color 0.2s cubic-bezier(0.075, 0.82, 0.165, 1);
  }
  .card-container {
    flex: 1;
    flex-direction: column;
    padding: 10px;
    overflow-y: auto;
    outline-offset: -3px;
    outline: 3px dashed #8c8c8c00;
    background: ${props => props.theme.palette.primary.light};
    transition: background 0.2s cubic-bezier(0.075, 0.82, 0.165, 1),
      outline 0.2s cubic-bezier(0.075, 0.82, 0.165, 1);
    &.droppable {
      outline: 3px dashed #8c8c8c;
    }
    &.over {
      outline-color: ${props => props.theme.palette.primary.main};
      background: ${props => (0, core_2.darken)(props.theme.palette.primary.light, 0.05)};
    }
  }
`;
const TaskBoard = props => {
    var _a;
    const { apiParams, taskTypeId, onSelectTask } = props;
    const [drop, setDrop] = (0, react_1.useState)();
    const [error, setError] = (0, react_1.useState)();
    const [dragTask, setDragTask] = (0, react_1.useState)();
    const [debounceDrag] = (0, core_ui_1.useTimeout)();
    const { tasks, isLoading, error: tasksError, findByType } = (0, useFindTasksByType_1.useFindTasksByType)(taskTypeId || 0);
    const manager = (0, useTaskBoard_1.useTaskBoard)(taskTypeId || 0, tasks);
    const sensors = (0, core_1.useSensors)((0, core_1.useSensor)(core_1.PointerSensor));
    const { taskEntity, manager: taskEntityManager } = (0, useGetTaskEntity_1.useGetTaskEntity)(((_a = drop === null || drop === void 0 ? void 0 : drop.task) === null || _a === void 0 ? void 0 : _a.id) || (dragTask === null || dragTask === void 0 ? void 0 : dragTask.id), true);
    const noColumns = ((manager === null || manager === void 0 ? void 0 : manager.columns) || []).length === 0;
    const dragHasSubTask = ((dragTask === null || dragTask === void 0 ? void 0 : dragTask.children) || []).length > 0;
    // move the task back to initial column
    const cancelDrop = () => {
        if (drop && manager) {
            manager.move(drop.task.id, drop.previousStatus, drop.previousPosition);
            setDrop(undefined);
        }
    };
    (0, react_1.useEffect)(() => {
        findByType(apiParams);
    }, [findByType, apiParams]);
    (0, react_1.useEffect)(() => {
        setError(tasksError);
    }, [tasksError]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.DndContext, { sensors: sensors, onDragStart: event => {
                const taskId = parseInt(event.active.id);
                const task = manager === null || manager === void 0 ? void 0 : manager.findTask(taskId);
                // delay drag to enable onClick events
                // prevent dragging if currently dragging a task
                !drop && debounceDrag(() => setDragTask(task), 100);
            }, onDragEnd: event => {
                var _a, _b;
                const newStatus = (_a = event.over) === null || _a === void 0 ? void 0 : _a.id;
                if (dragTask && manager && newStatus) {
                    const previousPosition = (_b = manager.indexOf(dragTask.id)) === null || _b === void 0 ? void 0 : _b.task;
                    manager.move(dragTask.id, newStatus);
                    setDrop({
                        task: dragTask,
                        newStatus,
                        previousPosition,
                        previousStatus: dragTask.status
                    });
                }
                setDragTask(undefined);
            }, onDragCancel: () => setDragTask(undefined) },
            react_1.default.createElement(StyledBoard, { className: noColumns ? 'no-columns' : undefined },
                noColumns && !isLoading && (react_1.default.createElement(core_ui_1.ErrorView, { title: 'Empty Board', description: 'There are no available Tasks to show in board.', icon: react_1.default.createElement(icons_1.TableChart, { color: 'disabled', className: 'icon' }) })),
                noColumns && isLoading && (react_1.default.createElement(core_ui_1.StyledCenterView, null,
                    react_1.default.createElement("div", { className: 'content' },
                        react_1.default.createElement(core_2.CircularProgress, { size: 64, color: 'primary' })))), manager === null || manager === void 0 ? void 0 :
                manager.columns.map(column => (react_1.default.createElement(BoardColumn_1.default, { column: column, manager: manager, dragTask: dragTask, key: column.state.name, onSelectTask: task => onSelectTask === null || onSelectTask === void 0 ? void 0 : onSelectTask(task, taskEntityManager) })))),
            react_1.default.createElement(core_1.DragOverlay, null, dragTask &&
                (dragHasSubTask ? (react_1.default.createElement(BoardItemWithSubTask_1.default, { isDragging: true, task: dragTask, isLoading: manager === null || manager === void 0 ? void 0 : manager.isLoading(dragTask.id) })) : (react_1.default.createElement(BoardItem_1.default, { isDragging: true, task: dragTask, isLoading: manager === null || manager === void 0 ? void 0 : manager.isLoading(dragTask.id) }))))),
        drop && manager && (react_1.default.createElement(TaskBoardStatusAction_1.default, { task: drop.task, target: drop.newStatus, taskEntity: taskEntity, findEventName: (taskStatus, targetStatus) => {
                var _a;
                return (_a = manager.findEvent(taskStatus, targetStatus)) === null || _a === void 0 ? void 0 : _a.name;
            }, setIsLoading: manager.setIsLoading, onCancel: cancelDrop, onError: error => {
                setError(error);
                cancelDrop();
            }, onChange: task => {
                // update task and refresh with updated status
                manager.update(task.id, task);
                manager.refresh();
                setDrop(undefined);
            } })),
        react_1.default.createElement(core_ui_1.AppSnackbar, { severity: 'error', open: !!error }, error === null || error === void 0 ? void 0 : error.message)));
};
exports.TaskBoard = TaskBoard;
exports.default = exports.TaskBoard;
//# sourceMappingURL=TaskBoard.js.map